import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useApp } from '../../contexts/AppContext';
import { useVerificarAcessoAba } from '../../hooks/usePermissoes';
import Button from '../common/Button';
import Modal from '../common/Modal';
import NotificacoesService from '../../services/notificacoesService';
import EditarPerfilModal from '../common/EditarPerfilModal';
import { PerfisService } from '../../services/perfisService';
import { NotificacaoRealtime, TipoNotificacao } from '../../types';
import WhatsAppWidget from '../WhatsAppWidget';
import PosVisitaModal from '../common/PosVisitaModal';

const Layout: React.FC = () => {
  const { user, logout } = useAuth();
  const { filialAtual, setFilialAtual, notificacoesNaoLidas, refreshNotificacoes } = useApp();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showNotificacoes, setShowNotificacoes] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showEditarPerfil, setShowEditarPerfil] = useState(false);
  const [notificacoes, setNotificacoes] = useState<NotificacaoRealtime[]>([]);
  const [perfis, setPerfis] = useState<any[]>([]);

  const menuItems = [
    {
      name: 'Início',
      path: '/inicio',
      icon: (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      roles: ['admin', 'gerente', 'operador', 'cliente']
    },
    {
      name: 'Cargas',
      path: '/cargas',
      icon: (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
      ),
      roles: ['admin', 'gerente', 'operador']
    },
    {
      name: 'Gestão de Agendamento',
      path: '/gestao-agendamento',
      icon: (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      roles: ['admin', 'gerente', 'operador']
    },
    {
      name: 'Gestão de Pedidos de Compra',
      path: '/gestao-pedidos',
      icon: (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      ),
      roles: ['admin', 'gerente', 'operador', 'cliente']
    },
    {
      name: 'Usuários',
      path: '/usuarios',
      icon: (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
        </svg>
      ),
      roles: ['admin']
    },
    {
      name: 'Agendar Visitas',
      path: '/agendar-visitas',
      icon: (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      roles: ['admin', 'gerente', 'operador', 'fornecedor', 'cliente', 'visitante']
    },
    {
      name: 'Gestão de Visitas',
      path: '/gestao-visitas',
      icon: (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        </svg>
      ),
      roles: ['admin', 'gerente', 'operador']
    },
    {
      name: 'Configurações',
      path: '/configuracoes',
      icon: (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      roles: ['admin', 'gerente']
    },
    {
      name: 'Área do RCA',
      path: '/area-rca',
      icon: (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        </svg>
      ),
      roles: ['admin', 'gerente', 'operador', 'cliente']
    },
    {
      name: 'BI Analítico',
      path: '/bi-analitico',
      icon: (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      roles: ['admin', 'gerente']
    },
    {
      name: 'Monitoramento de Sistema',
      path: '/monitoramento',
      icon: (
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      roles: ['admin', 'gerente']
    }
  ];

  const todasFiliais = [
    { id: 'FILIAL_1', nome: 'Filial 1 - UP Distribuidora de Produtos e Descartáveis LTDA' },
    { id: 'FILIAL_2', nome: 'Filial 2 - Aleplast Comércio de Produtos e Descartáveis LTDA' },
    { id: 'FILIAL_3', nome: 'Filial 3 - Alepack Industria e Comercio Plasticos LTDA' }
  ];

  // Admin/gerente veem todas as filiais; demais perfis veem apenas as filiais permitidas
  const filiais = (user?.perfil === 'admin' || user?.perfil === 'gerente' || user?.filiais?.includes('TODAS AS FILIAIS'))
    ? todasFiliais
    : todasFiliais.filter(f => user?.filiais?.includes(f.id));

  // Componente para renderizar item de menu somente se usuário tiver permissão
  const MenuItem: React.FC<{ item: typeof menuItems[0]; onClick?: () => void }> = ({ item, onClick }) => {
    const { temAcesso, carregando } = useVerificarAcessoAba(item.name);
    if (carregando || !temAcesso) return null;
    return (
      <Link
        key={item.path}
        to={item.path}
        onClick={onClick}
        className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors ${
          location.pathname === item.path
            ? 'bg-primary-700 text-white'
            : 'text-gray-300 hover:bg-gray-700 hover:text-white'
        }`}
      >
        {item.icon}
        <span className="ml-3">{item.name}</span>
      </Link>
    );
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  const handleAbrirNotificacoes = async () => {
    if (!user) return;
    try {
      const dados = await NotificacoesService.buscarDoUsuario(user.id);
      setNotificacoes(dados.map((n: any) => ({
        id: n.id,
        usuarioId: n.usuarioId || n.usuario_id,
        titulo: n.titulo,
        mensagem: n.mensagem,
        tipo: n.tipo,
        lida: n.lida,
        createdAt: n.createdAt || n.data_criacao
      })));
      setShowNotificacoes(true);
    } catch (error) {
      console.error('Erro ao carregar notificações:', error);
    }
  };

  const handleMarcarComoLida = async (id: string) => {
    try {
      await NotificacoesService.marcarComoLida(id);
      setNotificacoes(notificacoes.map(n => 
        n.id === id ? { ...n, lida: true } : n
      ));
      refreshNotificacoes();
    } catch (error) {
      console.error('Erro ao marcar notificação como lida:', error);
    }
  };

  const handleMarcarTodasComoLidas = async () => {
    if (!user) return;
    try {
      await NotificacoesService.marcarTodasComoLidas(user.id);
      setNotificacoes(notificacoes.map(n => ({ ...n, lida: true })));
      refreshNotificacoes();
    } catch (error) {
      console.error('Erro ao marcar todas como lidas:', error);
    }
  };

  // Carregar perfis para mapear IDs para nomes
  useEffect(() => {
    const carregarPerfis = async () => {
      try {
        const { data } = await PerfisService.buscarTodos();
        if (data) {
          setPerfis(data);
        }
      } catch (error) {
        console.error('Erro ao carregar perfis:', error);
      }
    };
    carregarPerfis();
  }, []);

  // Função para buscar nome do perfil por ID
  const getNomePerfil = (perfilId: string) => {
    const perfil = perfis.find(p => p.id === perfilId);
    return perfil ? perfil.nome : perfilId;
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Sidebar para desktop */}
      <div className="hidden md:flex md:flex-shrink-0">
        <div className="flex flex-col w-64">
          <div className="flex flex-col h-0 flex-1 bg-gray-800 border-r border-gray-200">
            {/* Logo */}
            <div className="flex items-center h-20 flex-shrink-0 px-4 bg-primary-600">
              <img 
                src="/Falcon Hub 2.png" 
                alt="Falcon Hub" 
                className="h-16 w-auto max-w-full object-contain"
              />
            </div>

            {/* Navigation */}
            <nav className="flex-1 px-2 py-4 space-y-1">
              {menuItems.map((item) => (
                <MenuItem key={item.path} item={item} />
              ))}
            </nav>

            {/* Support section */}
            <div className="flex-shrink-0 flex border-t border-gray-700 p-4">
              <a
                href="https://wa.me/5582991197455?text=Olá, preciso de suporte no sistema de agendamento."
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center w-full text-gray-300 hover:text-white hover:bg-gray-700 rounded-md p-2 transition-colors"
              >
                <svg className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
                <div className="flex-1">
                  <p className="text-sm font-medium">Fale com o desenvolvedor</p>
                  <p className="text-xs text-gray-400">Jhon Rodrigues - (82) 9 91197455</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile sidebar */}
      <div className={`md:hidden fixed inset-0 z-50 ${sidebarOpen ? 'block' : 'hidden'}`}>
        <div className="fixed inset-0 flex">
          <div className="relative flex w-full max-w-xs flex-1 flex-col bg-gray-800">
            {/* Close button */}
            <div className="absolute top-0 right-0 -mr-12 pt-2">
              <button
                type="button"
                className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                onClick={() => setSidebarOpen(false)}
              >
                <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Logo */}
            <div className="flex items-center h-20 flex-shrink-0 px-4 bg-primary-600">
              <img 
                src="/Falcon Hub 2.png" 
                alt="Falcon Hub" 
                className="h-16 w-auto max-w-full object-contain"
              />
            </div>

            {/* Navigation */}
            <nav className="flex-1 px-2 py-4 space-y-1">
              {menuItems.map((item) => (
                <MenuItem key={item.path} item={item} onClick={() => setSidebarOpen(false)} />
              ))}
            </nav>
          </div>
          <div className="w-14 flex-shrink-0" onClick={() => setSidebarOpen(false)}>
            {/* Force sidebar to close */}
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        {/* Top header */}
        <header className="bg-white shadow-sm border-b border-gray-200">
          <div className="flex items-center justify-between px-2 sm:px-4 lg:px-8 py-3 sm:py-4">
            <div className="flex items-center gap-2 flex-shrink-0">
              {/* Mobile menu button */}
              <button
                type="button"
                className="md:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
                onClick={() => setSidebarOpen(true)}
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>

              {/* Bem-vindo banner */}
              <div className="bg-primary-700 rounded-lg shadow-lg shadow-primary-700/20 px-2 sm:px-4 py-1.5 sm:py-2 text-white relative overflow-hidden flex items-center max-w-[120px] sm:max-w-none">
                <div className="relative z-10 truncate">
                  <h1 className="text-xs font-medium sm:text-sm sm:font-bold truncate">
                    Olá, {user?.nome || 'Jhon'}!
                  </h1>
                </div>
              </div>
            </div>

            {/* Filial selector */}
            <div className="flex-1 flex justify-center px-2 min-w-0">
              <div className="relative mx-auto flex items-center bg-white rounded-lg shadow shadow-primary-500/20 border border-gray-200 w-full max-w-[180px] sm:max-w-[300px] md:max-w-[500px] px-2 py-1.5 sm:px-3 sm:py-2">
                {/* Logo da filial selecionada */}
                <div className="mr-2 sm:mr-3 flex-shrink-0">
                  {filialAtual === 'FILIAL_1' && (
                    <img src="/Filial 1- UP DISTRIBUIDORA.png" alt="UP Distribuidora" className="h-6 sm:h-8 md:h-10 w-auto" />
                  )}
                  {filialAtual === 'FILIAL_2' && (
                    <img src="/Filial 2- Aleplast.png" alt="Aleplast" className="h-6 sm:h-8 md:h-10 w-auto" />
                  )}
                  {filialAtual === 'FILIAL_3' && (
                    <span className="text-base sm:text-xl md:text-2xl">🏭</span>
                  )}
                </div>
                <select
                  value={filialAtual}
                  onChange={(e) => setFilialAtual(e.target.value)}
                  className="flex-1 bg-transparent border-none focus:ring-0 text-xs sm:text-sm md:text-base font-medium appearance-none cursor-pointer pr-5 sm:pr-8 truncate min-w-0"
                >
                  {filiais.map(filial => (
                    <option key={filial.id} value={filial.id}>
                      {filial.nome}
                    </option>
                  ))}
                </select>
                <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-2 sm:space-x-4 flex-shrink-0">
              {/* Notifications */}
              <div className="relative">
                <Button variant="outline" size="sm" onClick={handleAbrirNotificacoes}>
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                  </svg>
                  {notificacoesNaoLidas > 0 && (
                    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center animate-pulse">
                      {notificacoesNaoLidas}
                    </span>
                  )}
                </Button>
              </div>

              {/* User menu */}
              <div className="relative">
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className="flex items-center space-x-1 sm:space-x-2 p-1 sm:p-2 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  {user?.foto_perfil ? (
                    <img
                      src={user.foto_perfil}
                      alt={user.nome}
                      className="h-8 w-8 sm:h-10 sm:w-10 md:h-20 md:w-20 rounded-full object-cover border-2 border-primary-500"
                    />
                  ) : (
                    <img
                      src="/Falcon Hub 2.png"
                      alt="Falcon Hub"
                      className="h-8 w-8 sm:h-10 sm:w-10 md:h-20 md:w-20 rounded-full object-cover border-2 border-primary-500"
                    />
                  )}
                  <div className="hidden md:block text-left">
                    <p className="text-sm font-semibold text-gray-900">{user?.nome}</p>
                    <p className="text-xs text-gray-500 capitalize">{getNomePerfil((user as any).perfil_id || user?.perfil)}</p>
                  </div>
                  <svg className="h-4 w-4 text-gray-400 hidden md:block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                {/* Dropdown menu */}
                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                    <div className="px-4 py-3 border-b border-gray-100">
                      <p className="text-sm font-medium text-gray-900">{user?.nome}</p>
                      <p className="text-xs text-gray-500">{user?.email}</p>
                    </div>
                    <button
                      onClick={() => {
                        setShowUserMenu(false);
                        setShowEditarPerfil(true);
                      }}
                      className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center"
                    >
                      <svg className="h-4 w-4 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      Editar Perfil
                    </button>
                    <button
                      onClick={() => {
                        setShowUserMenu(false);
                        navigate('/meus-dados');
                      }}
                      className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center"
                    >
                      <svg className="h-4 w-4 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      Meus Dados (LGPD)
                    </button>
                    <button
                      onClick={handleLogout}
                      className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center"
                    >
                      <svg className="h-4 w-4 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                      </svg>
                      Sair
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <Outlet />
            </div>
          </div>
        </main>
      </div>

      {/* Modal de Notificações */}
      <Modal
        isOpen={showNotificacoes}
        onClose={() => setShowNotificacoes(false)}
        title="Notificações"
        size="lg"
      >
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-500">
              {notificacoes.filter(n => !n.lida).length} notificações não lidas
            </p>
            {notificacoes.some(n => !n.lida) && (
              <Button variant="outline" size="sm" onClick={handleMarcarTodasComoLidas}>
                Marcar todas como lidas
              </Button>
            )}
          </div>

          <div className="space-y-2 max-h-96 overflow-y-auto">
            {notificacoes.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                Nenhuma notificação
              </div>
            ) : (
              notificacoes.map((notificacao) => (
                <div
                  key={notificacao.id}
                  className={`p-4 rounded-lg border ${
                    notificacao.lida ? 'bg-gray-50' : 'bg-blue-50 border-blue-200'
                  }`}
                >
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <h4 className="font-medium text-gray-900">{notificacao.titulo}</h4>
                      <p className="text-sm text-gray-600 mt-1">{notificacao.mensagem}</p>
                      <p className="text-xs text-gray-400 mt-2">
                        {new Date(notificacao.createdAt).toLocaleString('pt-BR')}
                      </p>
                    </div>
                    {!notificacao.lida && (
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleMarcarComoLida(notificacao.id)}
                      >
                        Marcar como lida
                      </Button>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </Modal>

      {/* Modal de Editar Perfil */}
      <EditarPerfilModal
        isOpen={showEditarPerfil}
        onClose={() => setShowEditarPerfil(false)}
      />

      {/* Widget de WhatsApp */}
      <WhatsAppWidget />

      {/* Modal de Pós Visita */}
      <PosVisitaModal />
    </div>
  );
};

export default Layout;
